var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 80,
    viewBox: "0 0 33 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3464 79.7511H20.4934C19.194 79.2639 18.1974 78.6364 17.5847 77.3297C17.4887 77.123 17.1048 76.0821 17.1048 75.9566V49.3354C16.8095 48.9736 16.1451 48.9884 15.8719 49.3354V75.8015C15.8719 76.429 15.2149 77.6324 14.7941 78.127C12.4538 80.9102 7.89148 79.6552 7.27136 76.0747L7.15324 30.0745C6.56264 29.3141 5.89083 29.7718 5.83916 30.6134L5.77272 50.0441C4.69487 52.842 1.34323 52.5098 0.294922 49.8817V25.2759C0.929814 21.9464 3.41771 19.5028 6.84317 19.237C13.1257 18.7424 20.0578 19.5988 26.4141 19.2592C29.8691 19.68 32.3939 22.3377 32.6818 25.8148C32.2536 33.3819 33.2355 41.5469 32.6818 49.0401C32.4308 52.4286 28.4812 53.1521 27.1893 50.0515L27.1228 30.6134C27.0711 29.602 26.1114 29.2993 25.7349 30.3107V75.9639C25.4544 77.8834 24.1034 79.1532 22.339 79.7511H22.3464Z",
    fill: "#4A3A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4825 16.1804C20.7962 16.1804 24.2932 12.6702 24.2932 8.34018C24.2932 4.01017 20.7962 0.5 16.4825 0.5C12.1688 0.5 8.67188 4.01017 8.67188 8.34018C8.67188 12.6702 12.1688 16.1804 16.4825 16.1804Z",
    fill: "#4A3A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManPurple);
export default __webpack_public_path__ + "static/media/man-purple.647d6880f2df6be3f34acf1b543a3b21.svg";
export { ForwardRef as ReactComponent };